































































import { Vue, Component, Prop } from "@/shared/vuepack";
import { BannerType } from "@/admin/types";
import { PartnerBanner, UserPermission } from "@/shared/types";
import { useUserStore } from "@/shared/store/user";
import { useNotifierStore } from "@/shared/store/notifier";
import { useBannerStore } from "@/shared/store/banner";
import DeleteBannerModal from "@/admin/components/partners/DeleteBannerModal.vue";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";

@Component({
  components: {DeleteBannerModal}
})
export default class BannerTable extends Vue {
  @Prop({required: true}) bannersType: BannerType;
  @Prop({ type: Array, required: true }) banners!: PartnerBanner[];
  @Prop({ }) loading: boolean;
  @Prop({ }) isEditing: boolean;
  @Prop() partnerId: number;

  userStore = useUserStore();
  notifierStore = useNotifierStore();
  bannerStore = useBannerStore();
  rolePermissions = useRolePermissionsStore();


  showDeleteBannerModal = false;
  bannerToDelete: any = null;

  get bannerTypeLabel (): string {
    return this.bannersType === "custom" ? "Custom Banners" : "Default Banners";
  }

  onCopyBannerFromTable (banner) {
    const payload = {
      titleA: banner.titleA,
      titleB: banner.titleB,
      description: banner.description,
      linkUrl: banner.linkUrl,
      linkText: banner.linkText
    };

    this.bannerStore.createPartnerBanner(
        Number(this.partnerId),
        payload
    );
  }

  openDeleteBannerModal (banner?: PartnerBanner) {
    this.bannerToDelete = banner || null;
    this.showDeleteBannerModal = true;
  }

  async confirmDeleteBanner (banner: PartnerBanner) {
    this.bannerStore.deletePartnerBanner(Number(this.partnerId), banner.bannerId).then(() => {
      this.$emit("refresh");
      this.hideDeleteBannerModal();
    });
  }

  hideDeleteBannerModal () {
    this.showDeleteBannerModal = false;
    this.bannerToDelete = null;
  }

  get hasEditPermission (): boolean {
    return this.rolePermissions.userHasAdminPermission(UserPermission.AdminPortalPartnerEdit);
  }

  get canDeleteBanner (): boolean {
    return !(this.bannerStore.customBanners.length === 1 && !this.bannerStore.displayDefaultBanners);
  }
}
